export default __webpack_public_path__ + "images/logoGoodScienceBeauty.b5fa1f222dd27cacf4f64d55b9f11553.svg"